import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';

export enum CustomerType {
  END_USER = 'end_user',
  TECHNICIAN = 'technician',
}

export enum PricingTier {
  NO_DISCOUNT = 'no_discount',
  BRONZE = 'bronze',
  SILVER = 'silver',
  GOLD = 'gold',
  RETAIL_MARKUP = 'retail_markup',
}

export interface Customer {
  id: number;
  name: string;
  phone: string;
  email?: string;
  address?: string;
  type: CustomerType;
  pricing_tier: PricingTier;
  branch_id: number;
  notes?: string;
  is_active: boolean;
  created_at: string;
}

export interface CustomerCreate {
  name: string;
  phone: string;
  email?: string;
  address?: string;
  type: CustomerType;
  pricing_tier?: PricingTier;
  branch_id: number;
  notes?: string;
}

export interface CustomerUpdate {
  name?: string;
  phone?: string;
  email?: string;
  address?: string;
  type?: CustomerType;
  member_status?: MemberStatus;
  pricing_tier?: PricingTier;
  notes?: string;
  is_active?: boolean;
}

const API_URL = `${API_BASE_URL}/customers`;

export const getCustomers = async (params?: {
  branch_id?: number;
  type?: CustomerType;
  pricing_tier?: PricingTier;
  search?: string;
  limit?: number;
  offset?: number;
}): Promise<Customer[]> => {
  const response = await api.get<Customer[]>(API_URL, { params });
  return response.data;
};

export const getCustomerById = async (id: number): Promise<Customer> => {
  const response = await api.get<Customer>(`${API_URL}/${id}`);
  return response.data;
};

export const searchCustomerByPhone = async (phone: string): Promise<Customer[]> => {
  const response = await api.get<Customer[]>(API_URL, { 
    params: { search: phone, limit: 10 } 
  });
  return response.data;
};

export const createCustomer = async (
  customer: CustomerCreate
): Promise<Customer> => {
  const response = await api.post<Customer>(API_URL, customer);
  return response.data;
};

export const updateCustomer = async (
  id: number,
  customer: CustomerUpdate
): Promise<Customer> => {
  const response = await api.put<Customer>(`${API_URL}/${id}`, customer);
  return response.data;
};

export const deleteCustomer = async (id: number): Promise<void> => {
  await api.delete(`${API_URL}/${id}`);
};

export const customerService = {
  getCustomers,
  getCustomerById,
  searchCustomerByPhone,
  createCustomer,
  updateCustomer,
  deleteCustomer,
};

